import React from 'react';
import PropTypes from 'prop-types';
import {
  PaginationSC,
  SizeChangerSC,
  PaginationButtonsWrapper,
  SizeChangeButton,
} from './pagination.styled';
import dlt from '../../../utils/default-lang';
import { TPagination } from '../../../types/pagination';
import { ReactComponent as LeftArrow } from '../../../assets/img/svg/left-arrow.svg';
import { ReactComponent as RightArrow } from '../../../assets/img/svg/right-arrow.svg';
import { BodyText } from '../../typography';
import { FormattedMessage } from 'react-intl';

/**
 * Component to handle pagination
 * @param {any} param0 props
 */
function Pagination({ pagination, onChange, isLoading, sizes, onPageSizeChange, showSizer }) {
  /**
   * Handle page change by arrows
   * @param {string} type type of movement
   */
  function onArrowClick(type) {
    if (onChange) {
      switch (type) {
        case 'next':
          onChange(pagination?.current_page + 1, pagination.per_page);
          break;
        case 'back':
          onChange(pagination?.current_page - 1, pagination.per_page);
          break;
        default:
          break;
      }
    }
  }

  /**
   * Handle page size change
   * @param {number} size size of page
   */
  function onSizeChange(size) {
    if (onPageSizeChange) {
      onPageSizeChange(pagination?.current_page, size);
    }
  }

  return (
    <PaginationSC>
      {showSizer && (
        <SizeChangerSC>
          {sizes.map((size) => (
            <SizeChangeButton
              active={pagination?.per_page === size}
              onClick={() => onSizeChange(size)}
              disabled={isLoading}
              key={size}
            >
              {size}
            </SizeChangeButton>
          ))}
        </SizeChangerSC>
      )}
      <PaginationButtonsWrapper>
        <BodyText className="bolder orange">
          {pagination?.from}-{pagination?.to}{' '}
          <FormattedMessage id="global_from" defaultMessage={dlt['global_from']} />{' '}
          {pagination?.total}
        </BodyText>
        <div className="arrow-wrap">
          <button
            disabled={pagination?.current_page < 2 || isLoading}
            onClick={() => onArrowClick('back')}
          >
            <LeftArrow />
          </button>
          <button
            disabled={pagination?.current_page === pagination?.last_page || isLoading}
            onClick={() => onArrowClick('next')}
          >
            <RightArrow />
          </button>
        </div>
      </PaginationButtonsWrapper>
    </PaginationSC>
  );
}

Pagination.defaultProps = {
  sizes: [10, 50, 100],
  isLoading: false,
  showSizer: true,
};

Pagination.propTypes = {
  /**
   * Pagination config
   */
  pagination: TPagination.isRequired,
  /**
   * Callback on pagination change
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Callback on page size change
   */
  onPageSizeChange: PropTypes.func.isRequired,
  /**
   * Array of sizes to choose from
   */
  sizes: PropTypes.arrayOf(PropTypes.number),
  /**
   * Bool if show sizer
   */
  showSizer: PropTypes.bool,
  /**
   * isLoading disables buttons
   */
  isLoading: PropTypes.bool,
};

export default Pagination;
